<template>
  <div class="modal fade" id="priceModelConfigModal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-exchange mr-5"></i>{{ "price_model_settings" | translate }}</h4>
        </div>
        <div class="modal-body">
          <form ref="preisModelForm">
            <template v-for="alert in alerts">
              <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
                <h4>
                  <i v-if="alert.type == 'success' || alert.type == 'warning' " class="icon fa fa-check"></i>
                  <i class="icon fa fa-ban" v-else></i>
                  {{ 'alert_' + alert.type | translate }}!</h4>
                <template v-if="alert.type === 'danger' && alert.message.message === undefined">
                  <span v-for="msg, key in alert.message">
                    {{ msg[0] }}<br>
                  </span>
                </template>
                <template v-else-if="alert.type === 'danger' && alert.message.message !== undefined">
                  {{ alert.message.message | translate }}
                </template>
                <template v-else>
                  {{ alert.message }}
                </template>
              </b-alert>
            </template>
            <div class="row">
              <div class="col-xs-12 mb-10">
                <div class="input-group col-xs-12">
                  <label for="price_model">{{ 'priceModel' | translate }}</label>
                  <select v-model="modelConfig.config.id" id="price_model" class="form-control"
                          @change="changePriceModel(modelConfig.config.id)">
                    <option v-for="priceModel in this.priceModels" :value="priceModel">{{ priceModel | translate }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div v-if="modelConfig.config.id === 'connect2'">
              <div class="row">
                <div class="col-xs-12 mb-10">
                  <div class="input-group col-xs-12">
                    <label for="stockPercentage">{{ "stockPercentage" | translate }}</label>
                    <input v-validate="'required|decimal'" name="stockPercentage" v-on:blur="modelConfig.config.stockPercentage = stringToNumber(modelConfig.config.stockPercentage)"
                           v-model="modelConfig.config.stockPercentage" id="stockPercentage" class="form-control" key="stockPercentage"/>
                    <div><span v-show="errors.has('stockPercentage')"
                               class="small text-danger">{{ errors.first('stockPercentage') }}</span></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 mb-10">
                  <div class="input-group col-xs-12">
                    <label for="type">{{ "type" | translate }}</label>
                    <select v-model="modelConfig.config.type" id="type" class="form-control">
                      <option v-for="type in types" :value="type">{{ type }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="modelConfig.config.id === 'bestPrice'">
              <div class="row">
                <div class="col-xs-12 mb-10">
                  <div class="input-group col-xs-12">
                    <label for="stock">{{ "stock" | translate }}</label>
                    <input v-validate="'required|decimal'" name="stock" v-model="modelConfig.config.stock" id="stock"
                           class="form-control" key="stock" v-on:blur="modelConfig.config.stock = stringToNumber(modelConfig.config.stock)"/>
                    <div><span v-show="errors.has('stock')" class="small text-danger">{{ errors.first('stock') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" id="confirmEdit" :disabled="errors.any() || deactivateSaveButton" class="btn btn-app btn-success"
                  @click="send(modelConfig)"><span class="fa fa-save "></span>{{ 'save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: [
    'modelConfig', 'modelRefreshConfig'
  ],
  data() {
    return {
      alerts: [],
      priceModels: ['connect2', 'bestPrice'],
      types: ['highest', 'lowest'],
      deactivateSaveButton: false
    }
  },
  methods: {
    stringToNumber(value) {
      return Number(value)
    },
    changePriceModel(priceModel) {
      this.$validator.reset()
      if (priceModel === 'connect2') {
        this.modelConfig.config = {
          id: this.modelConfig.config.id,
          stockPercentage: 0,
          type: ''
        }
      } else {
        this.modelConfig.config = {
          id: this.modelConfig.config.id,
          stock: 0
        }
      }
    },
    send(config) {
      this.deactivateSaveButton = true
      API.post(`marketplaces`, config)
        .then($res => {
          this.alerts.push({dismiss: 4, type: 'success', message: 'success', icon: 'icon fa fa-check', show: true})
          Object.assign(this.modelRefreshConfig, config);
        })
        .catch(error => {
          this.alerts.push({
            dismiss: 4,
            type: 'danger',
            message: error.response.data,
            icon: 'icon fa fa-ban',
            show: true
          })
        }).finally(() => {
        this.deactivateSaveButton = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/PriceModelConfigModal.vue